import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import * as login from './login.actions';
import * as fromLogin from './login.reducer';

export const actions = login;
export * from './login.model';

export interface State {
  readonly authLogin: fromLogin.State;
}

export const reducers: ActionReducerMap<State, login.Actions> = {
  authLogin: fromLogin.reducer,
};

export type LoginState = fromLogin.State;

const selectState = createFeatureSelector<LoginState>('authLogin');

export const select = {
  loginError: createSelector(selectState, fromLogin.getLoginError),
  verify2FAError: createSelector(selectState, fromLogin.getVerify2FAError),
  pending: createSelector(selectState, fromLogin.getPending),
  state: selectState,
};
